import React, { Component } from 'react';
import { Keyboard } from 'react-native';
import { Tabs, Tab } from '../ui';

export class SettingsTabs extends Component {
  render() {
    const navigation = this.props.navigation;
    const { routes, index } = this.props.navigation.state;

    return (
      <Tabs>
        {routes.map((route, idx) => {
          const active = index === idx;
          return (
            <Tab
              active={active}
              currentTabIndex={idx}
              key={route.routeName}
              title={route.routeName}
              amountOfTabs={routes.length - 1}
              onPress={() => {
                Keyboard.dismiss();
                navigation.navigate(route.routeName);
              }}
            />
          );
        })}
      </Tabs>
    );
  }
}
